import { render, staticRenderFns } from "./SDCardActions.vue?vue&type=template&id=21e421a6&scoped=true&"
import script from "./SDCardActions.vue?vue&type=script&lang=js&"
export * from "./SDCardActions.vue?vue&type=script&lang=js&"
import style0 from "./SDCardActions.vue?vue&type=style&index=0&id=21e421a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e421a6",
  null
  
)

export default component.exports